import { QueryKey, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

// ref: https://www.notion.so/Excessive-API-calls-fetching-select-options-2e9ed78da73080688c96ff192b3cb027
// TanstackQuery hooks will return `isFetching` and `isFetchingNextPage`.
// However, the values may be outdated if hook is called multiple times in the same render.
//
// This hook provides a function that can be called to get the fetch status directly from `queryClient`.
// The value obtained this way should be up-to-date.

export const useCheckIsIdle = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (queryKey: QueryKey) => {
      const fetchStatus = queryClient.getQueryState(queryKey)?.fetchStatus;
      return fetchStatus === 'idle';
    },
    [queryClient]
  );
};
